// extracted by mini-css-extract-plugin
export default {"navToggler":"nav-toggler_navToggler__dlZwL"};